module.exports = __webpack_public_path__ + "img/icon-xuangu1_3cf55.png";